import React, { Fragment } from "react";
import { Header } from 'semantic-ui-react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        const timeoutSeconds = this.getTimeoutSeconds();
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
            secondsToRecover: timeoutSeconds
        };
        this.recoveryTimeoutId = null;
        this.recoveryIntervalId = null;
    }

    getTimeoutSeconds = () => {
        const configuredTimeout = Number(this.props.recoveryTimeoutSeconds);
        if (Number.isFinite(configuredTimeout) && configuredTimeout > 0) {
            return Math.floor(configuredTimeout);
        }

        return 10;
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState(
            {
                hasError: true,
                error: error,
                errorInfo: info
            }
        );

        if (this.props.enableAutoRecover) {
            this.startRecoveryTimer();
        }
    }

    componentWillUnmount() {
        this.clearRecoveryTimers();
    }

    clearRecoveryTimers = () => {
        if (this.recoveryTimeoutId) {
            clearTimeout(this.recoveryTimeoutId);
            this.recoveryTimeoutId = null;
        }

        if (this.recoveryIntervalId) {
            clearInterval(this.recoveryIntervalId);
            this.recoveryIntervalId = null;
        }
    }

    startRecoveryTimer = () => {
        this.clearRecoveryTimers();

        const timeoutSeconds = this.getTimeoutSeconds();
        this.setState({ secondsToRecover: timeoutSeconds });

        this.recoveryIntervalId = setInterval(() => {
            this.setState(prev => ({
                secondsToRecover: prev.secondsToRecover > 0 ? prev.secondsToRecover - 1 : 0
            }));
        }, 1000);

        this.recoveryTimeoutId = setTimeout(() => {
            this.clearRecoveryTimers();
            if (this.props.onRecover) {
                this.props.onRecover();
            }
            else {
                window.location.href = "/";
                window.location.reload();
            }
        }, timeoutSeconds * 1000);
    }

    render() {
        if (this.state.hasError) {
            const showAutoRecoverMessage = !!this.props.enableAutoRecover;
            return (<Fragment>
                <Header as="h1">Oops :(</Header>
                <div>Something went wrong</div>
                {showAutoRecoverMessage && <div>Returning to home screen in {this.state.secondsToRecover} seconds...</div>}
                <details style={{ whiteSpace: 'pre-wrap' }}>
                    {this.state.error && this.state.error.toString()}
                    <br />
                    {this.state.errorInfo.componentStack}
                </details>
            </Fragment>
            );
        }

        return this.props.children;
    }
}